module.exports = __webpack_public_path__ + "static/media/play-btn-green.e9735680.webp";